import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

import common from './common';

// Custom error handler to suppress known API issues while still logging important errors
const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors) {
    // Filter out known 'components' field errors that are API-side issues
    const knownApiIssueErrors = graphQLErrors.filter(err => 
      err.message?.includes("Error trying to resolve field 'components'")
    );
    
    const otherErrors = graphQLErrors.filter(err => 
      !err.message?.includes("Error trying to resolve field 'components'")
    );
    
    // Log known issues as warnings (low severity)
    if (knownApiIssueErrors.length > 0) {
      console.warn(
        `[GraphQL - Known API Issue] components field unavailable (${operation.operationName}). This is a temporary API limitation.`
      );
    }
    
    // Log actual errors that need attention
    if (otherErrors.length > 0) {
      otherErrors.forEach(({ message, locations, path }) =>
        console.error(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        )
      );
    }
  }
  
  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }
});

// Create HTTP link for GraphQL requests
const httpLink = new HttpLink({
  uri: `${common.baseUrl}v3/GraphQL`,
  credentials: "include"
});

// Define the ApolloClient with the menus GraphQL api endpoint, the common.js defines basic info we utilize for our APIs; in this case we fetch baseUrl from the common file.
// set credentials to include so cookies are passsed along with each request https://www.apollographql.com/docs/react/networking/authentication/
const client = new ApolloClient({
  link: errorLink.concat(httpLink),
  cache: new InMemoryCache()
});

export default client;